export default __webpack_public_path__ + "static/media/1@2x-min.83168612.png";